import { CreateFirstUseCase } from './types';

export const categories: CreateFirstUseCase[] = [
  {
    slug: 'social',
    name: 'Digital Marketing',
    imagePath: '/images/category/digital-marketing.png',
    type: 'category',
  },
  {
    slug: 'marketing',
    name: 'Print Marketing',
    imagePath: '/images/category/print-marketing.png',
    type: 'category',
  },
  {
    slug: 'merchandise',
    name: 'Merchandise',
    imagePath: '/images/category/merchandise.png',
    type: 'category',
  },
  {
    slug: 'labels',
    name: 'Packaging Design',
    imagePath: '/images/category/packaging-design.png',
    type: 'useCase',
  },
  {
    slug: 'branding',
    name: 'Branding',
    imagePath: '/images/category/branding.png',
    type: 'category',
  },
  {
    slug: 'stationery',
    name: 'Stationery',
    imagePath: '/images/category/stationery.png',
    type: 'category',
  },
  {
    slug: 'business',
    name: 'Business Materials',
    imagePath: '/images/category/business-materials.png',
    type: 'category',
  },
  {
    slug: 'covers',
    name: 'Publishing',
    imagePath: '/images/category/publishing.png',
    type: 'category',
  },
];
